import { RequiredOptions } from '_app/hooks/useProductOptions'
import { ProductCustomOptions } from '_app/types/product'
import { CartItem } from '../types'
import { CartProductDetails } from './CartProductDetails'

export type ProductDetailsProps = {
  options: ProductCustomOptions | undefined;
  requiredOptions: RequiredOptions | undefined;
  cartItem: CartItem;
  isDrawerMode?: boolean;
};

export const ShowItemDetails = ({
  options,
  requiredOptions,
  cartItem,
  isDrawerMode,
}: ProductDetailsProps) => {
  const availableRequiredOptions =
    requiredOptions?.filter(({ options }) => options?.length > 1)?.length !== 0

  const cartItemHasOptions =
    (cartItem.entered_options?.option || []).length > 0

  const cartItemHasCustomizableOptions =
    !!cartItem.customizable_options?.length

  const cartItemHasEmptyOnlyPaintingOption = (
      cartItem.customizable_options?.length === 1 &&
      cartItem.customizable_options[0]?.values[0]?.label === 'bez malowania'
  )

  if (
    cartItemHasEmptyOnlyPaintingOption ||
    !(
      availableRequiredOptions ||
      cartItemHasOptions ||
      cartItemHasCustomizableOptions
    )
  ) {
    return <></>
  }

  return (
    <>
       <CartProductDetails
          options={options}
          requiredOptions={requiredOptions}
          cartItem={cartItem}
          isDrawerMode={isDrawerMode}
       />
    </>
  )
}
